import { render, staticRenderFns } from "./Links.vue?vue&type=template&id=a463ef5e&scoped=true&"
import script from "./Links.vue?vue&type=script&lang=js&"
export * from "./Links.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a463ef5e",
  null
  
)

export default component.exports